// src/components/forms/fieldsConfig/clientFields.js

/* ---------------------------------------------------
 *  UTILITAIRES TÉLÉPHONE
 * --------------------------------------------------- */

// Nettoyage et formatage flexible des numéros FR & internationaux
const formatPhoneNumber = (phone = "") => {
  if (!phone) return "";

  let cleaned = phone.replace(/[^\d]/g, "");

  // 00 → retirer le préfixe international
  if (cleaned.startsWith("00")) cleaned = cleaned.slice(2);

  // Format FR 0X → transformer en +33
  if (cleaned.startsWith("0") && cleaned.length === 10) {
    cleaned = "33" + cleaned.slice(1);
  }

  return cleaned;
};

// Validation souple
const validatePhone = (value) => {
  if (!value) return true; // Laisse les champs optionnels passer

  const cleaned = formatPhoneNumber(value);

  // Accepte tout numéro international entre 8 et 15 chiffres
  return /^[0-9]{8,15}$/.test(cleaned);
};

// Validation spécifique propriétaire
const validateProprietairePhone = (value, typeOccupation) => {
  if (typeOccupation !== "locataire") return "";

  if (!value?.trim()) return "Le numéro du propriétaire est requis pour les locataires";

  if (!validatePhone(value)) return "Numéro de téléphone du propriétaire invalide";

  return "";
};

/* ---------------------------------------------------
 *  DÉFINITION DES CHAMPS FORMULAIRE
 * --------------------------------------------------- */

export const clientCreationFields = [
  {
    name: "nom",
    label: "Nom Complet",
    type: "text",
    required: true,
    placeholder: "Nom complet ou raison sociale",
    validate: (value) => (!value?.trim() ? "Le nom est obligatoire" : ""),
    col: 12
  },
  {
    name: "type",
    type: "hidden",
    defaultValue: "particulier",
    hidden: true
  },
  {
    name: "statut",
    type: "hidden",
    defaultValue: "prospect",
    hidden: true
  },


  /* --- Téléphone Principal --- */
  {
    name: "telephones",
    label: "Téléphone principal",
    type: "tel",
    // required: true,
    placeholder: "01 23 45 67 89",
    validate: (value) => {
      if (!value?.trim()) return "Le téléphone est requis";
      if (!validatePhone(value)) return "Numéro de téléphone invalide";
      return "";
    },
    helpText: "Format flexible: 01 23 45 67 89, +33123456789, 0033123456789…",
    col: 12
  },

  /* --- Email Principal --- */
  {
    name: "emails",
    label: "Email principal",
    type: "email",
    // required: true,
    placeholder: "email@exemple.com",
    // validate: (value) => {
    //   // if (!value?.trim()) return "L'email est requis";
    //   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    //   return emailRegex.test(value) ? "" : "Email invalide";
    // },
    col: 12
  },

  /* --- Occupation --- */

  // {
  //   name: "interphone",
  //   label: "Numéro d'interphone",
  //   type: "text",
  //   col: 6
  // },
  // {
  //   name: "numeroAppartement",
  //   label: "Numéro d'appartement",
  //   type: "text",
  //   col: 6
  // },
  {
    name: "codeAcces",
    label: "Code d'accès",
    type: "text",
    col: 6
  },
  {
    name: "typeOccupation",
    label: "Type d'occupation",
    type: "select",
    defaultValue: "proprietaire",
    options: [
      { value: "proprietaire", label: "Propriétaire" },
      { value: "locataire", label: "Locataire" }
    ],
    // placeholder: "Type d'occupation",
    col: 6
  },
  {
    name: "numeroProprietaire",
    label: "Téléphone du propriétaire",
    type: "tel",
    placeholder: "01 23 45 67 89",
    helpText: "Uniquement requis pour les locataires",
    col: 6,
    condition: (data) => data.typeOccupation === "locataire"
  },
  {
    name: "source",
    label: "Source du client",
    type: "select",
    required: true,
    options: [
      { value: "appel", label: "Appel" },
      { value: "whatsapp", label: "WhatsApp" },
      { value: "mail", label: "Boite Mail" },
      { value: "technicien", label: "Technicien" },

    ],
    placeholder: "-- Séléctionnez source du client --",
    col: 6
  },

  /* --- Champs d'adresse cachés pour stocker les composants --- */
  {
    name: "address_street",
    type: "hidden",
    hidden: true
  },
  {
    name: "address_city",
    type: "hidden",
    hidden: true
  },
  {
    name: "address_zip",
    type: "hidden",
    hidden: true
  },
  {
    name: "address_state",
    type: "hidden",
    hidden: true
  },
  {
    name: "address_country",
    type: "hidden",
    defaultValue: "France"
  },
  {
    name: "address_map_url", // Added map_url hidden field
    type: "hidden",
    hidden: true
  },

  /* --- Adresses avec autocomplete --- */
  {
    name: "adresses",
    label: "Adresse complète",
    type: "autocomplete", // Type spécial pour SearchAutoComplete
    placeholder: "Commencez à taper une adresse...",
    col: 12,
    helpText: "Utilisez l'autocomplétion pour remplir automatiquement l'adresse",
    required: true,
    validate: (value) => (!value?.trim() ? "L'adresse est requise" : "")
  }
];

export const clientUpdateFields = [...clientCreationFields];

/* ---------------------------------------------------
 *  FORMATAGE AVANT ENVOI API
 * --------------------------------------------------- */

export const formatClientData = (formData) => {
  const formatted = {
    nom: formData.nom?.trim(),
    type: formData.type || "particulier",
    statut: formData.statut || "prospect",
    source: formData.source || "appel"
  };

  // Occupation
  ["typeOccupation", "interphone", "numeroAppartement", "codeAcces"].forEach((key) => {
    if (formData[key] !== undefined && formData[key] !== null) {
      formatted[key] = formData[key].toString().trim();
    }
  });

  // Numéro de propriétaire (conditionnel)
  if (formData.typeOccupation === "locataire" && formData.numeroProprietaire) {
    formatted.numeroProprietaire = formatPhoneNumber(formData.numeroProprietaire);
  }

  // Téléphones → tableau
  if (formData.telephones) {
    formatted.telephones = [formatPhoneNumber(formData.telephones)];
  }

  // Emails → tableau
  if (formData.emails) {
    formatted.emails = [formData.emails.trim().toLowerCase()];
  }

  // ---------- ADRESSES (with lat/lng support) ----------
  // Extract lat/lng from formData (set by handleSelectAddress)
  const lat = formData.address_lat != null ? parseFloat(formData.address_lat) : null;
  const lng = formData.address_lng != null ? parseFloat(formData.address_lng) : null;

  // Build location object only if both lat and lng are valid numbers
  let location = null;
  if (!isNaN(lat) && !isNaN(lng) && lat !== null && lng !== null) {
    location = {
      type: 'Point',
      coordinates: [lng, lat] // GeoJSON: [longitude, latitude]
    };
  }

  // Adresses - utiliser les champs individuels si disponibles
  const addressObject = {
    formatted: formData.adresses?.trim() || '',
    street: formData.address_street || formData.street || '',
    city: formData.address_city || formData.city || '',
    zip: formData.address_zip || formData.zip || '',
    state: formData.address_state || formData.state || '',
    country: formData.address_country || formData.country || 'France',
    map_url: formData.address_map_url || formData.map_url || '',
    location: location
  };

  // CORRECTION: Si street est vide, utiliser la première partie de formatted
  if (!addressObject.street && addressObject.formatted) {
    const parts = addressObject.formatted.split(',').map(p => p.trim());
    if (parts.length > 0) {
      addressObject.street = parts[0];
    }
  }

  // Si l'adresse formatée existe, créer les tableaux d'adresses
  if (addressObject.formatted.trim()) {
    // Créer un tableau avec l'adresse pour billing et shipping
    formatted.billingAddresses = [addressObject];
    formatted.shippingAddresses = [addressObject]; // Même adresse pour livraison par défaut
  } else {
    // S'assurer que les tableaux d'adresses existent même si vides
    formatted.billingAddresses = [];
    formatted.shippingAddresses = [];
  }

  return formatted;
};

/* ---------------------------------------------------
 *  PRÉ-REMPLISSAGE
 * --------------------------------------------------- */

export const prepareClientFormData = (client) => {
  if (!client) return {};

  // Récupérer la première adresse de facturation ou de livraison
  const billingAddress = client.billingAddresses?.[0] || {};
  const shippingAddress = client.shippingAddresses?.[0] || {};

  // Utiliser l'adresse de facturation par défaut, sinon l'adresse de livraison
  const address = billingAddress.formatted ? billingAddress : shippingAddress;

  return {
    nom: client.nom || "",
    type: client.type || "particulier",
    statut: client.statut || "prospect",
    source: client.source || "appel",

    typeOccupation: client.typeOccupation || "",
    interphone: client.interphone || "",
    numeroAppartement: client.numeroAppartement || "",
    codeAcces: client.codeAcces || "",
    numeroProprietaire: client.numeroProprietaire || "",

    telephones: client.telephones?.[0] || "",
    emails: client.emails?.[0] || "",

    // Adresse complète formatée
    adresses: address.formatted || "",

    // Champs d'adresse individuels
    address_street: address.street || "",
    address_city: address.city || "",
    address_zip: address.zip || "",
    address_state: address.state || "",
    address_country: address.country || "France",
    address_map_url: address.map_url || "" // Added map_url
  };
};

/* ---------------------------------------------------
 *  VALIDATION FINALE FORMULAIRE
 * --------------------------------------------------- */

export const validateClientForm = (data) => {
  const errors = {};

  if (!data.nom?.trim()) errors.nom = "Le nom est requis";

  // Téléphone
  if (!data.telephones?.trim())
    errors.telephones = "Le téléphone est requis";
  else if (!validatePhone(data.telephones))
    errors.telephones = "Numéro de téléphone invalide";

  // Email
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  // if (!data.emails?.trim()) errors.emails = "L'email est requis";
  // else if (!emailRegex.test(data.emails))
  //   errors.emails = "Email invalide";

  // Adresse
  if (!data.adresses?.trim()) errors.adresses = "L'adresse est requise";

  // Téléphone propriétaire locataire
  const ownerError = validateProprietairePhone(
    data.numeroProprietaire,
    data.typeOccupation
  );
  if (ownerError) errors.numeroProprietaire = ownerError;

  return errors;
};

/* ---------------------------------------------------
 *  FONCTIONS POUR EXTRACTION D'ADRESSE
 * --------------------------------------------------- */

// Fonction pour extraire les composants d'adresse depuis une adresse formatée
export const extractAddressComponents = (formattedAddress) => {
  if (!formattedAddress) return {
    formatted: '',
    street: '',
    city: '',
    zip: '',
    state: '',
    country: 'France',
    map_url: '' // Added map_url
  };

  // Initialiser avec des valeurs par défaut
  const components = {
    formatted: formattedAddress,
    street: '',
    city: '',
    zip: '',
    state: '',
    country: 'France',
    map_url: '' // Added map_url
  };

  // Pour une adresse Google, on peut essayer de parser par virgules
  const parts = formattedAddress.split(',').map(part => part.trim());

  if (parts.length > 0) {
    // Le premier élément est généralement la rue + numéro
    components.street = parts[0];
  }

  if (parts.length > 1) {
    // Le dernier élément est généralement le pays
    const lastPart = parts[parts.length - 1];
    if (lastPart) {
      components.country = lastPart;
    }

    // Chercher le code postal (5 chiffres pour la France)
    for (const part of parts) {
      const zipMatch = part.match(/\b(\d{5})\b/);
      if (zipMatch) {
        components.zip = zipMatch[1];
        // La ville est généralement juste avant le code postal
        const cityPart = part.replace(zipMatch[0], '').trim();
        if (cityPart && !components.city) {
          components.city = cityPart;
        }
        break;
      }
    }

    // Si pas de code postal trouvé, le 2ème élément pourrait être la ville
    if (parts.length > 2 && !components.city) {
      components.city = parts[1];
    }
  }

  return components;
};

// Fonction pour extraire les composants depuis les détails Google Places
export const extractFromPlaceDetails = (placeDetails) => {
  const result = {
    formatted: placeDetails.formatted_address || '',
    street: '',
    city: '',
    zip: '',
    state: '',
    country: 'France',
    map_url: placeDetails.url || '',
    lat: placeDetails.geometry?.location?.lat,
    lng: placeDetails.geometry?.location?.lng
  };

  // 1. Extraire depuis les composants Google
  placeDetails.address_components?.forEach((component) => {
    const types = component.types || [];

    // Rue: numéro + nom de rue
    if (types.includes('street_number')) {
      result.street = component.long_name + (result.street ? ' ' + result.street : '');
    }
    if (types.includes('route')) {
      result.street += (result.street ? ' ' : '') + component.long_name;
    }

    // Ville
    if (types.includes('locality') && !result.city) {
      result.city = component.long_name;
    }
    if (types.includes('postal_town') && !result.city) {
      result.city = component.long_name;
    }

    // Code postal
    if (types.includes('postal_code') && !result.zip) {
      result.zip = component.long_name;
    }

    // Région/État
    if (types.includes('administrative_area_level_1') && !result.state) {
      result.state = component.short_name || component.long_name;
    }

    // Pays
    if (types.includes('country') && !result.country) {
      result.country = component.long_name;
    }
  });

  // 2. Fallback: parser l'adresse formatée si des composants manquent
  if (result.formatted) {
    const formattedParts = result.formatted.split(',').map(p => p.trim());

    // Cas typique français: "Rue, Code Postal Ville, Pays"
    if (formattedParts.length >= 3) {
      // Le premier élément est généralement la rue
      if (!result.street) {
        result.street = formattedParts[0];
      }

      // Le deuxième élément contient généralement code postal + ville
      if (formattedParts.length >= 2) {
        const cityZipPart = formattedParts[1];

        // Chercher le code postal (5 chiffres)
        const zipMatch = cityZipPart.match(/\b(\d{5})\b/);
        if (zipMatch && !result.zip) {
          result.zip = zipMatch[1];

          // Extraire la ville
          const cityFromPart = cityZipPart.replace(zipMatch[0], '').trim();
          if (cityFromPart && !result.city) {
            result.city = cityFromPart;
          }
        } else if (!result.city) {
          // Si pas de code postal, prendre tout comme ville
          result.city = cityZipPart;
        }
      }

      // Le dernier élément est le pays
      if (!result.country && formattedParts.length > 0) {
        result.country = formattedParts[formattedParts.length - 1];
      }
    }

    // Chercher spécifiquement le code postal si pas encore trouvé
    if (!result.zip) {
      const zipMatch = result.formatted.match(/\b(\d{5})\b/);
      if (zipMatch) {
        result.zip = zipMatch[1];
      }
    }
  }

  // 3. Fallback ultime pour chaque champ
  if (!result.street && result.formatted) {
    const parts = result.formatted.split(',').map(p => p.trim());
    if (parts.length > 0) {
      result.street = parts[0];
    }
  }

  if (!result.city && result.formatted) {
    // Essayer d'extraire la ville après le code postal
    const afterZipMatch = result.formatted.match(/\b\d{5}\b\s+(.+?),/);
    if (afterZipMatch) {
      result.city = afterZipMatch[1];
    }
  }

  return result;
};

/* ---------------------------------------------------
 *  OPTIONS & FORMATAGES
 * --------------------------------------------------- */

export const getTypeOccupationOptions = () => [
  { value: "", label: "Sélectionner" },
  { value: "proprietaire", label: "Propriétaire" },
  { value: "locataire", label: "Locataire" }
];

export const formatOccupationDetails = (client) => {
  if (!client) return "";

  const d = [];

  if (client.typeOccupation)
    d.push(client.typeOccupation === "proprietaire" ? "Propriétaire" : "Locataire");

  if (client.numeroAppartement) d.push(`Appt: ${client.numeroAppartement}`);
  if (client.interphone) d.push(`Interphone: ${client.interphone}`);
  if (client.codeAcces) d.push(`Code: ${client.codeAcces}`);
  if (client.numeroProprietaire && client.typeOccupation === "locataire")
    d.push(`Prop: ${client.numeroProprietaire}`);

  return d.join(" • ");
};

// Fonction pour créer un lien Google Maps à partir d'une adresse
export const createGoogleMapsUrl = (address) => {
  if (!address) return '';

  const components = [];
  if (address.street) components.push(encodeURIComponent(address.street));
  if (address.city) components.push(encodeURIComponent(address.city));
  if (address.zip) components.push(encodeURIComponent(address.zip));
  if (address.country) components.push(encodeURIComponent(address.country));

  if (components.length === 0 && address.formatted) {
    components.push(encodeURIComponent(address.formatted));
  }

  if (components.length > 0) {
    return `https://www.google.com/maps/search/?api=1&query=${components.join(',+')}`;
  }

  return '';
};

export default {
  creation: clientCreationFields,
  update: clientUpdateFields,
  format: formatClientData,
  prepare: prepareClientFormData,
  validate: validateClientForm,
  formatPhoneNumber,
  getTypeOccupationOptions,
  formatOccupationDetails,
  extractAddressComponents,
  extractFromPlaceDetails,
  createGoogleMapsUrl
};